import { Disease } from "../types";

interface IndicationData {
  indications: Array<{
    name: string;
    patient_population: number;
    new_patients_per_year: number;
    economic_cost_per_patient: number | null;
    years_of_impact: number | null;
    scientific_name: string;
    gene_of_interest: string;
    description: string;
    companies: string[];
    citations: {
      [key: string]: string[];
    };
  }>;
}

export async function loadIndicationData(
  diseaseName: string
): Promise<Partial<Disease>> {
  try {
    // Map disease names to their file names
    const fileNameMap: { [key: string]: string } = {
      "Parkinson's disease": "parkinsons",
      "Huntington's disease": "huntingtons",
      "Wet AMD": "wet_amd",
      "Spinal muscular atrophy": "spinal_muscular_atrophy",
    };

    const fileName =
      fileNameMap[diseaseName] ||
      diseaseName
        .toLowerCase()
        .replace(/[']/g, "")
        .replace(/[^a-z\s]/g, "")
        .replace(/\s+/g, "_");

    console.log(`Fetching indication data from: /indications/${fileName}.json`);

    const response = await fetch(`/indications/${fileName}.json`);
    if (!response.ok) {
      console.warn(
        `No indication data found for ${diseaseName} (${fileName}.json): ${response.status} ${response.statusText}`
      );
      return {};
    }

    const data: IndicationData = await response.json();
    const indication = data.indications[0];

    return {
      scientificName: indication.scientific_name,
      geneOfInterest: indication.gene_of_interest,
      description: indication.description,
      companies: indication.companies,
      citations: indication.citations,
    };
  } catch (error) {
    console.error(`Error loading indication data for ${diseaseName}:`, error);
    console.error("Stack trace:", (error as Error).stack);
    return {};
  }
}

export async function enrichDiseaseWithIndicationData(
  disease: Disease
): Promise<Disease> {
  const indicationData = await loadIndicationData(disease.name);
  return {
    ...disease,
    ...indicationData,
  };
}
